import { InjectionToken, type Type } from '@angular/core';
import type { SpinoffCreateOrgDialogComponent } from './spinoff-create-org-dialog.component';

export type { SpinoffCreateOrgDialogComponent };

/**
 * 단체 만들기 다이얼로그 컴포넌트를 지연 로딩한다. 다이얼로그(Material form-field·input 포함)는 처음 열 때만
 * 필요해, 정적 import 로 두면 앱 초기 번들에 실린다. `MatDialog.open()` 직전에 `await`로 받아 쓴다.
 */
export async function loadSpinoffCreateOrgDialog(): Promise<Type<SpinoffCreateOrgDialogComponent>> {
  const { SpinoffCreateOrgDialogComponent } = await import('./spinoff-create-org-dialog.component');
  return SpinoffCreateOrgDialogComponent;
}

/**
 * 로더를 주입해서 쓰는 곳(org-switcher)이 테스트에서 실제 청크를 받지 않고 호출 여부만 검증할 수 있게 하는 토큰.
 * 기본값은 위 `loadSpinoffCreateOrgDialog`다 — 앱이 따로 제공할 필요는 없다(배럴로 export 하지 않는다).
 */
export const SPINOFF_CREATE_ORG_DIALOG_LOADER = new InjectionToken<() => Promise<Type<SpinoffCreateOrgDialogComponent>>>(
  'SPINOFF_CREATE_ORG_DIALOG_LOADER',
  { providedIn: 'root', factory: () => loadSpinoffCreateOrgDialog },
);
